export const createSVG = ({
  width,
  height
}: {
  width: number;
  height: number;
}) => {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttribute('width', `${width}`);
  svg.setAttribute('height', `${height}`);
  svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
  svg.setAttribute('version', '1.1');
  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');

  return svg;
};

export const createPath = ({
  stroke,
  d,
  strokeWidth,
  fill = 'none'
}: {
  d: string;
  stroke?: string;
  fill?: string;
  strokeWidth?: number;
}) => {
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

  path.setAttribute('d', d);
  if (stroke) path.setAttribute('stroke', stroke);
  if (fill) path.setAttribute('fill', fill);
  if (strokeWidth) path.setAttribute('stroke-width', `${strokeWidth}`);

  return path;
};

// Render the svg <path> element
export const getCurvePathData = (points: number[][], smoothing = 0.2) => {
  // append first 2 points for closed paths
  points = points.concat(points.slice(0, 2));

  // Properties of a line
  const line = (pointA: number[], pointB: number[]) => {
    const lengthX = pointB[0] - pointA[0];
    const lengthY = pointB[1] - pointA[1];

    return {
      length: Math.sqrt(Math.pow(lengthX, 2) + Math.pow(lengthY, 2)),
      angle: Math.atan2(lengthY, lengthX)
    };
  };

  // Position of a control point
  const controlPoint = (
    current: number[],
    previous: number[],
    next: number[],
    reverse?: boolean
  ) => {
    const p = previous || current;
    const n = next || current;
    const o = line(p, n);

    const angle = o.angle + (reverse ? Math.PI : 0);
    const length = o.length * smoothing;

    const x = current[0] + Math.cos(angle) * length;
    const y = current[1] + Math.sin(angle) * length;
    return [x, y];
  };

  let pathData: { type: string; values: number[] }[] = [];
  pathData.push({ type: 'M', values: [points[0][0], points[0][1]] });

  for (let i = 1; i < points.length; i++) {
    const point = points[i];
    const cp1 = controlPoint(points[i - 1], points[i - 2], point);
    const cp2 = controlPoint(point, points[i - 1], points[i + 1], true);

    pathData.push({
      type: 'C',
      values: [cp1[0], cp1[1], cp2[0], cp2[1], point[0], point[1]]
    });
  }

  // copy last commands 1st controlpoint to first curveto
  const comLast = pathData[pathData.length - 1];
  const valuesLastC = comLast.values;
  const valuesFirstC = pathData[1].values;

  pathData[1] = {
    type: 'C',
    values: [valuesLastC[0], valuesLastC[1], valuesFirstC.slice(2)].flat()
  };
  // delete last curveto
  pathData = pathData.slice(0, pathData.length - 1);

  return pathData
    .map(
      (com) =>
        `${com.type}${com.values.map((value) => +value.toFixed(4)).join(' ')}`
    )
    .join(' ');
};
